import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { LoginserviceService } from "src/app/services/loginservice.service";
import { SmsService } from 'src/app/services/SmsService';

import { Socialusers } from "../../Socialuser";
import { UserServiceService } from "src/app/services/user-service.service";
import { AuthService } from "src/app/services/auth.service";
import { Subscription } from "rxjs";
import { HostService } from 'src/app/services/host.service';


@Component({
  selector: "app-valider-telephone",
  templateUrl: "./valider-telephone.component.html",
  styleUrls: ["./valider-telephone.component.scss"],
})
export class ValidationTelephoneComponent implements OnInit, OnDestroy {
  public loginForm!: UntypedFormGroup;
  public bgImage: any;
  user: any;
  isSignedin!: boolean;
  public resets :boolean
  socialusers = new Socialusers();
  phoneUser: string;
  userIn: any;
  public index: number = 0;

  //Subscription
  verifySubscription: Subscription

  constructor(
    public fb: UntypedFormBuilder,
    private sanitizer: DomSanitizer,
    public loginService: LoginserviceService,
    private toastr: ToastrService,
    public phone: SmsService,
    private service: UserServiceService, 
    public router: Router,
    public authService: AuthService,
    public hostService:HostService

  ) {}

  ngOnInit(): void {
    this.resets = false ;
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle(
      "url("+this.hostService.getHttpsImage()+"images/others/se-connecter_locationsenegal.svg)"
    );

    const infoUser = localStorage.getItem("infoUser");

    this.user = JSON.parse(infoUser!);
   
    if (infoUser != undefined || infoUser != null) {
      
      this.phoneUser = this.user['phone'];

      this.initForm();

      
    } else {

      this.router.navigateByUrl('/');

    }

  }

  initForm() {

    this.loginForm = this.fb.group({

      number: [this.phoneUser, Validators.required],
      code: [
        null,
        Validators.compose([Validators.required,  Validators.pattern("^[0-9]{6}")])],  
    });

  }

  public onLoginFormSubmit(): void {
      
    if(this.loginForm.valid) {

      let obj = {
        code: this.loginForm.value.code,
        user_phone: this.phoneUser,
      };  

      if(this.index < 3 || this.index == 4) {
    
        this.verifySubscription = this.phone.verifyCode(obj).subscribe((data: any) => {
      
          if(data.status) {

            sessionStorage.setItem("user", JSON.stringify(data.user));
            localStorage.setItem("user", JSON.stringify(data.user));
    
            this.toastr.success(data.message);

            this.authService.isLoggedIn = true;
    
            this.router.navigateByUrl("/compte-utilisateur").then();

          } else {

            this.toastr.error(data.message);

          }
        
          this.index++;

        });

      } else {

        this.toastr.error("veuillez réessayer ultérieurement");

      }

    }

  }


  /**
   * Envoir d'un nouveau code
  */
  public  reset () {
    
    let obj = {
      'id': this.user.id,
      'user_phone': this.user.phone,
    };

    this.phone.phoneNum(obj).subscribe((data:any)=>{
  
      if(data.status) {

      this.toastr.success("Un nouveau code de validation vous a étè envoyer sur votre telephone");

      } else {

        this.toastr.error(data.message)

      }

      this.index++;

    });
    
  }

  ngOnDestroy(): void {

    localStorage.removeItem("infoUser");

    if(this.index != 0) {

      this.verifySubscription.unsubscribe();

    }

  }
}
